import { Z as fallback, $ as attr, a1 as bind_props, S as pop, a0 as stringify, Q as push } from "./index.js";
function XIcon($$payload, $$props) {
  push();
  let size = fallback($$props["size"], "24");
  let strokeWidth = fallback($$props["strokeWidth"], 2);
  let customClass = fallback($$props["class"], "");
  if (size !== "100%") {
    size = size.slice(-1) === "x" ? size.slice(0, size.length - 1) + "em" : parseInt(size) + "px";
  }
  $$payload.out += `<svg xmlns="http://www.w3.org/2000/svg"${attr("width", size)}${attr("height", size)} fill="none" viewBox="0 0 24 24" stroke="currentColor"${attr("stroke-width", strokeWidth)} stroke-linecap="round" stroke-linejoin="round"${attr("class", `feather feather-x ${stringify(customClass)}`)}><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`;
  bind_props($$props, { size, strokeWidth, class: customClass });
  pop();
}
export {
  XIcon as X
};
